function increaseQuantity(event, id) {
  event.preventDefault();
  document.querySelector(`quantity-input[id="Quantity-${id}"] .quantity__button[name="plus"]`).click();
}

function decreaseQuantity(event, id) {
  event.preventDefault();
  document.querySelector(`quantity-input[id="Quantity-${id}"] .quantity__button[name="minus"]`).click();
}

function formatEuroNlFromCents(cents) {
  return new Intl.NumberFormat('nl-NL', {
    style: 'currency',
    currency: 'EUR',
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  })
    .format((Number(cents) || 0) / 100)
    .replace(/\s+/g, '')
    .replace('€-', '-€');
}

function formatEuroNlFromAmount(amount) {
  return new Intl.NumberFormat('nl-NL', {
    style: 'currency',
    currency: 'EUR',
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  })
    .format(Number(amount) || 0)
    .replace(/\s+/g, '')
    .replace('€-', '-€');
}

function setTextForAll(selector, value) {
  document.querySelectorAll(selector).forEach((el) => {
    el.textContent = value;
  });
}

document.addEventListener('bundler:loaded', function () {
  if (window.bndlr && typeof window.bndlr.updateCartDiscounts === 'function') {
    window.bndlr.updateCartDiscounts();
  }
});

document.addEventListener('bundler:total_cart_values', function (e) {
  const vatIncluded = sessionStorage.getItem('pricesIncludeVat');

  const {
    total_amount_original = 0,
    total_amount_discounted = 0,
    discount_amount = 0,
    discounted_cart_object = null,
  } = e.detail || {};

  // Overzicht rechts
  setTextForAll('#cart-price_subtotal', formatEuroNlFromCents(total_amount_discounted));

  const totalTaxAmount = (total_amount_discounted * 0.21) / 100;
  setTextForAll('#cart-price_tax', formatEuroNlFromAmount(totalTaxAmount));

  setTextForAll('#cart-price_discount', `-${formatEuroNlFromCents(discount_amount)}`);

  document.querySelectorAll('[data-cart-discount]').forEach((el) => {
    if (discount_amount > 0) {
      el.classList.add('flex');
      el.classList.remove('hidden');
    } else {
      el.classList.remove('flex');
      el.classList.add('hidden');
    }
  });

  const totalPriceAmount = (total_amount_discounted * 1.21) / 100;
  setTextForAll('#cart-price_total', formatEuroNlFromAmount(totalPriceAmount));

  // Productregels: totaalprijs van het gekozen aantal tonen
  if (discounted_cart_object && discounted_cart_object.items) {
    discounted_cart_object.items.forEach((item) => {
      const itemElement = document.querySelector(
        `[data-cart-variant="${item.variant_id}"]`
      );

      if (!itemElement) {
        console.warn(
          `Cart item element not found for variant ID: ${item.variant_id}`
        );
        return;
      }

      const originalLinePrice =
        typeof item.original_line_price !== 'undefined'
          ? Number(item.original_line_price)
          : Number(item.line_price || 0);

      const discountedLinePrice =
        typeof item.line_price !== 'undefined'
          ? Number(item.line_price)
          : originalLinePrice;

      const hasDiscount =
        originalLinePrice > discountedLinePrice;

      function formatDisplayPriceFromCents(cents) {
        if (vatIncluded == 'true') {
          return formatEuroNlFromAmount(
            ((Number(cents) || 0) * 1.21) / 100
          );
        }

        return formatEuroNlFromCents(cents);
      }

      itemElement
        .querySelectorAll('[data-unit-price]')
        .forEach((el) => {
          el.textContent =
            formatDisplayPriceFromCents(
              discountedLinePrice
            );
        });

      itemElement
        .querySelectorAll('[data-old-unit-price]')
        .forEach((el) => {
          el.textContent =
            formatDisplayPriceFromCents(
              originalLinePrice
            );
        });

      itemElement
        .querySelectorAll(
          '[data-old-unit-price-wrapper]'
        )
        .forEach((el) => {
          if (hasDiscount) {
            el.classList.remove('hidden');
          } else {
            el.classList.add('hidden');
          }
        });
    });
  } else {
    console.warn('Discounted cart object is undefined or missing items.');
  }
});

var cartEvent = new CustomEvent('bundler:total_cart_values', {
  detail: {
    total_amount_original: 0,
  },
});

document.dispatchEvent(cartEvent);